import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ExponeaStockNotificationComponent } from '../../../../../module/exponea/exponea-stock-notification.component';
import { TrayComponent } from '../../../../../ui/widget/tray/tray.component';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { IParentView } from '../layout/product-view-layout.abstract';

@Component({
    selector: 'product-view-tray',
    templateUrl: './product-view-tray.component.html',
    styleUrl: './product-view-tray.component.scss',
    standalone: true,
    imports: [CommonModule, ExponeaStockNotificationComponent, OffClickDirective, TrayComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewTrayComponent extends UiComponent {
    @Input({ required: true })
    product!: ProductDecorator<IProductDataV3>;

    @Input({ required: true })
    parentView!: IParentView;

    /**
     * We use it to trigger tray resize tray
     */
    trayResizeTrigger = 0;

    override ngOnInit() {
        this.subscriptions.add(this.parentView.detectChanges$.subscribe(() => this.detectChanges()));

        super.ngOnInit();
    }

    resizeTray() {
        this.trayResizeTrigger++;

        this.detectChanges();
    }
}
